namespace Portico.Models.Enterprise {
    import psgm = apigateway.models;

    export interface IAddress {
        id: number;
		type: number | string;
        address1: string;
        address2: string;
        city: string;
        state: string;
        zip: string;
        country: string;
    }

    export interface IPartialAddress {
        address1: string;
        address2?: string;
        city: string;
        state: string;
        zip: string;
    }

    export class Address implements IAddress, IPartialAddress {
        id: number;
		type: number | string;
        address1: string;
        address2: string;
        city: string;
        state: string;
        zip: string;
        country: string;

        constructor(obj?: IAddress | any) {
            this.id = null;
            this.type = null;
            this.address1 = '';
            this.address2 = '';
            this.city = '';
            this.state = '';
            this.zip = '';
			this.country = 'US';

            if (obj) {
                this.id = obj.id || obj.addressId || null;
				this.type = obj.type || obj.addressType || null;
                this.address1 = obj.address1 || obj.addressOne || '';
				this.address2 = obj.address2 || obj.addressTwo || '';
				this.city = obj.city || '';
				this.state = obj.state || '';
				this.zip = obj.zip || '';
				this.country = obj.country || 'US';
            }
        }

        mapToEnterpriseCoordinatorAddress() : psgm.EnterpriseCoordinatorSharedAddressUpsearchModel {
            return {
                addressId: this.id,
                addressType: typeof this.type === 'number' ? this.type : Portico.Models.Gateway.AddressType[this.type],
                addressOne: this.address1,
                addressTwo: this.address2,
                city: this.city,
                state: this.state,
                zip: this.zip,
                country: this.country
            } as psgm.EnterpriseCoordinatorSharedAddressUpsearchModel
        }
    }
}
